import { Action } from '@ngrx/store';

import { HideLoader } from '../../../../shared/decorators/hide-loader';
import { ShowLoader } from '../../../../shared/decorators/show-loader';
import { ClinicalRecordType } from '../clinical-record-type.model';

export enum ClinicalRecordTypeActionTypes {
  LoadClinicalRecordTypes = '[ClinicalRecordTypes] Load',
  LoadClinicalRecordTypesSuccess = '[ClinicalRecordTypes] Load success',
  LoadClinicalRecordTypesFail = '[ClinicalRecordTypes] Load fail',
}

@ShowLoader()
export class LoadClinicalRecordTypes implements Action {
  readonly type = ClinicalRecordTypeActionTypes.LoadClinicalRecordTypes;
}
@HideLoader(ClinicalRecordTypeActionTypes.LoadClinicalRecordTypes)
export class LoadClinicalRecordTypesSuccess implements Action {
  readonly type = ClinicalRecordTypeActionTypes.LoadClinicalRecordTypesSuccess;
  constructor(public payload: ClinicalRecordType[]) { }
}
@HideLoader(ClinicalRecordTypeActionTypes.LoadClinicalRecordTypes)
export class LoadClinicalRecordTypesFail implements Action {
  readonly type = ClinicalRecordTypeActionTypes.LoadClinicalRecordTypesFail;
  constructor(public payload: string) { }
}


export type ClinicalRecordTypeActions =
  LoadClinicalRecordTypes | LoadClinicalRecordTypesSuccess | LoadClinicalRecordTypesFail;
